import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Textarea } from "../components/ui/textarea";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";

const SLOTS = [
  ["head_code", "Codice nell'<head> (es. script AdSense Auto Ads)"],
  ["header_728", "Banner superiore 728x90 (home, liste, pagina gioco)"],
  ["sidebar_300", "Laterale 300x250 (pagina gioco)"],
  ["game_bottom", "Sotto il gioco (pagina gioco)"],
];

function useSiteSettings() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setS({ ads: {}, ...(r.data || {}) })).catch(() => setS({ ads: {} }));
  }, []);
  const save = async (body) => {
    try {
      const r = await api.put("/admin/settings", body);
      setS({ ads: {}, ...r.data });
      toast.success("Salvato");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return [s, setS, save];
}

export function AdminAds() {
  const [s, setS, save] = useSiteSettings();
  if (!s) return null;
  return (
    <div className="space-y-6 max-w-3xl" data-testid="admin-ads">
      <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "Oswald" }}>Pubblicità</h1>
      <p className="text-sm text-slate-300">Incolla il codice dei tuoi annunci (Google AdSense, GameMonetize, ecc.). Gli spazi vuoti non vengono mostrati. Il file ads.txt è già pubblicato su /ads.txt.</p>
      {SLOTS.map(([k, label]) => (
        <div key={k} className="space-y-2">
          <Label className="text-slate-200">{label}</Label>
          <Textarea rows={5} value={s.ads?.[k] || ""} onChange={(e) => setS({ ...s, ads: { ...s.ads, [k]: e.target.value } })} className="font-mono text-xs bg-white/5 text-white border-white/15" data-testid={`ads-${k}`} />
        </div>
      ))}
      <Button onClick={() => save({ ads: s.ads })} className="bg-[#fc0] text-[#043856] hover:bg-yellow-300 font-bold" data-testid="ads-save-btn">Salva annunci</Button>
      <div className="rounded-xl border border-white/10 bg-[#0d2233] p-5 space-y-3" data-testid="walkthrough-settings">
        <h2 className="text-lg font-bold text-white">Video soluzioni GameMonetize (Walkthrough)</h2>
        <p className="text-sm text-slate-300">Mostra sotto ogni gioco il video soluzione di GameMonetize. Con gli annunci attivi guadagni sugli annunci del video player.</p>
        <label className="flex items-center gap-3 text-sm"><Switch checked={s.walkthrough_enabled !== false} onCheckedChange={(v) => save({ walkthrough_enabled: v })} data-testid="walkthrough-enabled-switch" /> Mostra video soluzioni</label>
        <label className="flex items-center gap-3 text-sm"><Switch checked={s.walkthrough_ads === true} onCheckedChange={(v) => save({ walkthrough_ads: v })} data-testid="walkthrough-ads-switch" /> Annunci nel video player</label>
      </div>
    </div>
  );
}

export function AdminSettings() {
  const [s, setS, save] = useSiteSettings();
  if (!s) return null;
  return (
    <div className="space-y-6 max-w-2xl" data-testid="admin-settings">
      <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "Oswald" }}>Impostazioni</h1>
      <div className="space-y-2">
        <Label className="text-slate-200">Nome del sito</Label>
        <Input value={s.site_title || ""} onChange={(e) => setS({ ...s, site_title: e.target.value })} className="bg-white/5 text-white border-white/15" data-testid="settings-title" />
      </div>
      <div className="space-y-2">
        <Label className="text-slate-200">Descrizione del sito</Label>
        <Textarea rows={3} value={s.site_description || ""} onChange={(e) => setS({ ...s, site_description: e.target.value })} className="bg-white/5 text-white border-white/15" data-testid="settings-description" />
      </div>
      <Button onClick={() => save({ site_title: s.site_title, site_description: s.site_description })} className="bg-[#fc0] text-[#043856] hover:bg-yellow-300 font-bold" data-testid="settings-save-btn">Salva impostazioni</Button>
    </div>
  );
}
